// extracted by mini-css-extract-plugin
export var videoContainer = "_k8-0";
export var videoIframe = "_k8-3";
export var videoLink = "_k8-1";
export var videoOverlay = "_k8-4";
export var videoOverlayText = "_k8-5";
export var videoWrapper = "_k8-2";